import {Observable} from 'rxjs';

export type FieldType = 'select' | 'multiSelect' | 'selectAsync' | 'number' | 'text' | 'percent' | 'time';

interface FieldConfig {
  label: string;
  type: FieldType;
  placeholder: string;
  unit?: string;
  options?: { label: string; value: any }[];
  asyncOptions?: Observable<{ label: string; value: any }[]>
}

export type FieldConfigMap = {
  [key: string]: FieldConfig;
};

export const isSelectField = (type: FieldType): boolean =>
  type === 'select' || type === 'selectAsync';
